<script lang="ts" setup>
import { MMLink, MMText } from '@mm-frontend/mm-web-ui-kit';
</script>

<template>
  <MMText font="Body M/Regular" class="privacy-policy">
    <span>Продолжая, вы принимаете</span>
    <MMLink to="https://legal.mm.ru/#polzovatelskoe_soglashenie?utm_source=mm.ru" design="accented" target="_blank"> условия </MMLink>
    <span>обработки персональных данных и</span>
    <MMLink to="https://magnit.ru/terms?utm_source=mm.ru" design="accented" target="_blank"> правила </MMLink>
    <span>Программы&nbsp;лояльности</span>
  </MMText>
</template>

<style lang="stylus">
.privacy-policy
  .mm-link
    display inline
</style>
